import React from "react";

const DefaultUser = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M18 9.198c-3.23 0-5.86 2.615-5.86 5.798 0 3.184 2.63 5.8 5.86 5.8 3.229 0 5.86-2.616 5.86-5.8 0-3.183-2.631-5.798-5.86-5.798ZM14.466 22.627c-3.174 0-5.77 2.55-5.77 5.669v2.108c0 1.973 1.65 3.596 3.66 3.596h11.287c2.01 0 3.661-1.623 3.661-3.596v-2.108c0-3.118-2.596-5.669-5.77-5.669h-7.068Z"
        />
        <path
            fill={fill}
            d="M18 2C9.178 2 2 9.052 2 17.72c0 3.005.878 5.897 2.458 8.367.173.27.447.46.762.531.316.071.647.016.921-.153.274-.17.469-.439.54-.749.073-.31.017-.635-.155-.905A13.15 13.15 0 0 1 4.44 17.72c0-7.37 6.058-13.322 13.56-13.322 7.502 0 13.554 5.952 13.554 13.322 0 2.549-.74 5-2.08 7.092-.172.27-.228.595-.156.905.072.31.267.58.54.749.275.169.606.224.922.153.315-.07.59-.262.762-.531A15.515 15.515 0 0 0 34 17.719C34 9.052 26.822 2 18 2Z"
        />
    </svg>
);

export default DefaultUser;
